import {computed} from 'vue';
import {useRoute} from '@typed-router';
import {useRequestHeaders} from '#imports';

export function useComesFromAdvancedSearch() {
    const route = useRoute();
    const referrer = import.meta.server ? useRequestHeaders(['referer']).referer : document.referrer;
    const referrerIsFromAdvancedSearch = !!referrer && referrer.includes('/s/advanced');

    return computed<boolean>(() => !!route.query?.advancedSearchId && referrerIsFromAdvancedSearch);
}
